// React
import React from 'react'

// Next
import Head from 'next/head'
import { GetStaticProps } from 'next'

// Components
import { Pricing } from '@/components/blocks/pricing'

// Utils
import { getLandingStaticProps } from '@/utils/ui/landing/get-static-props'

// i18n
import { useTranslation } from 'next-i18next'

const PricingPage: React.FC = () => {
  const { t } = useTranslation('routes/pricing')

  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: t('meta.title'),
    description: t('meta.description'),
    publisher: {
      '@type': 'Organization',
      name: 'Supermeme.ai',
      logo: {
        '@type': 'ImageObject',
        url: 'https://supermeme.ai/static/logo-big.png',
      },
    },
    mainEntity: {
      '@type': 'Product',
      name: 'Supermeme.ai',
      description: t('meta.description'),
      category: 'Software',
      offers: {
        '@type': 'AggregateOffer',
        priceCurrency: 'USD',
        availability: 'https://schema.org/InStock',
        lowPrice: 6.49,
        highPrice: 99.99,
      },
    },
  }

  return (
    <>
      <Head>
        <title>{t('meta.title')}</title>
        <meta name='description' content={t('meta.description')} />
        <meta property='og:url' content='https://supermeme.ai/pricing' />
        <link rel='canonical' href='https://supermeme.ai/pricing' />
        <script
          type='application/ld+json'
          dangerouslySetInnerHTML={{ __html: JSON.stringify(jsonLd) }}
        />
      </Head>

      <>
        <div className='my-10 space-y-12'>
          <Pricing />
        </div>
      </>
    </>
  )
}

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return getLandingStaticProps({
    locale,
    namespaces: [
      'common',
      'routes/pricing',
      'components/login-form',
      'components/pricing',
    ],
  })
}

export default PricingPage
